import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Activity, Dog, Globe, GraduationCap, Heart } from 'lucide-react';

export default function ResearchGroupsTab() {
  return (
              <div className="grid md:grid-cols-2 gap-4">
                <a href="https://caninegeneticslab.vet.cornell.edu" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center">
                          <GraduationCap className="w-5 h-5 text-red-600" />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-medium">Cornell Canine Genetics Lab</h4>
                          <p className="text-sm text-muted-foreground">
                            Baker Institute - identifies genetic variants for hereditary diseases
                          </p>
                          <p className="text-xs text-primary mt-1">caninegeneticslab.vet.cornell.edu</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://vet.purdue.edu/discovery/ekenstedt/" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
                          <GraduationCap className="w-5 h-5 text-amber-600" />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-medium">Purdue Canine Genetics Lab</h4>
                          <p className="text-sm text-muted-foreground">
                            Dr. Ekenstedt's lab - solves genetic diseases through testing
                          </p>
                          <p className="text-xs text-primary mt-1">vet.purdue.edu</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.canine-genetics.org.uk" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                          <Globe className="w-5 h-5 text-blue-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Canine Genetics Centre (UK)</h4>
                            <Badge variant="secondary" className="text-xs">30+ Variants</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Dr. Mellersh - eye diseases, neurological disorders across 50+ breeds
                          </p>
                          <p className="text-xs text-primary mt-1">canine-genetics.org.uk</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://dogagingproject.org" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
                          <Activity className="w-5 h-5 text-green-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Dog Aging Project</h4>
                            <Badge variant="secondary" className="text-xs">Citizen Science</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Analyzes 40-60M genetic variations per dog for aging and longevity studies
                          </p>
                          <p className="text-xs text-primary mt-1">dogagingproject.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://darwinsark.org/darwins-dogs" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                          <Dog className="w-5 h-5 text-purple-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Darwin's Dogs</h4>
                            <Badge variant="secondary" className="text-xs">Behavior</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Research into behavioral traits in dogs - free DNA testing for participants
                          </p>
                          <p className="text-xs text-primary mt-1">darwinsark.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.tgen.org/news/canine-cancer-genome-project-enters-phase-ii-omics/" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-pink-100 flex items-center justify-center">
                          <Heart className="w-5 h-5 text-pink-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Canine Cancer Genome Project</h4>
                            <Badge variant="secondary" className="text-xs">Cancer</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            TGen - multi-omics profiling for osteosarcoma, lymphoma, and soft tissue sarcoma
                          </p>
                          <p className="text-xs text-primary mt-1">tgen.org</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
              </div>
  );
}
